export default "__VITE_ASSET__235e06e5__"